import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { InputComponent } from '../../shared/components/from-input/input.component';

function dobNotInFuture(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const selectedDate = new Date(control.value);
  const today = new Date();

  selectedDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return selectedDate > today ? { futureDob: true } : null;
}

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputComponent, MatDialogModule],
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  form!: FormGroup;
  genderOptions: any[] = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Non-identifying', value: 'non-identifying' },
    { label: 'Prefer not to say', value: 'prefernottosay' },
  ];
  customErrorMessages = {
    firstName: { required: 'Please enter a first name.' },
    lastName: { required: 'Please enter a last name.' },
    personalEmail: {
      required: 'Personal email is required',
      email: 'Please enter a valid email address',
    },
    schoolEmail: {
      required: 'School email is required',
      email: 'Please enter a valid email address',
    },
    parentEmail: {
      required: 'Parent email is required',
      email: 'Please enter a valid email address',
    },
    parentName: {
      required: 'Parent/Guardian name is required',
    },
    dob: {
      required: 'Date of birth is required',
      futureDob: 'Date of birth cannot be a future date.',
    },
    schoolName: { required: 'Please select a school' },
    gender: { required: 'Please select a gender' },
    ethnicity: { required: 'Ethnicity is required' },
    yearLevel: {
      required: 'Year level is required',
      pattern: 'Year level must be a number',
      min: 'Year level must be at least 1',
      max: 'Year level must be 12 or less',
    },
  } as const;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      personalEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          ),
        ],
      ],
      schoolEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          ),
        ],
      ],
      parentEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          ),
        ],
      ],
      parentName: ['', Validators.required],
      dob: ['', [Validators.required, dobNotInFuture]],
      schoolName: ['', Validators.required],
      gender: ['', Validators.required],
      ethnicity: ['', Validators.required],
      yearLevel: [
        '',
        [
          Validators.pattern('^[0-9]*$'),
          Validators.min(1),
          Validators.max(12),
        ],
      ],
    });
  }

  // Optional: Add methods for save and cancel
  onSave(): void {
    if (this.form.valid) {
      // console.log('Form data:', this.form.value);
      // Add your save logic here
    } else {
      this.form.markAllAsTouched();
    }
  }

  onCancel(): void {
    // Add your cancel logic here
    this.form.reset();
  }
}
